module.exports = __webpack_public_path__ + "assets/images/glasses-01.d9489bf56290d02f2932208f0973b151.svg";